import {
  calculateDayDifference,
  getCurrentDay,
  isBeforeDate,
  isSameOrBeforeDate
} from '@/utils/DateHelpers'

export const isActivePrice = (price, compareDate = getCurrentDay()) => {
  if (!price?.start_date) return false

  const hasStarted = isSameOrBeforeDate(price.start_date, compareDate)

  if (!hasStarted) return false

  if (!price.end_date) return true

  return isSameOrBeforeDate(compareDate, price.end_date)
}

export const isFuturePrice = (price, compareDate = getCurrentDay()) => {
  if (!price?.start_date) return false

  return isBeforeDate(compareDate, price.start_date)
}

export const getLatestPrice = (
  priceList = [],
  compareDate = getCurrentDay()
) => {
  if (!Array.isArray(priceList)) return null

  const activePrices = priceList.filter((price) => {
    return isActivePrice(price, compareDate)
  })

  if (!activePrices.length) return null

  const sortedPriceList = [...activePrices].sort((a, b) => {
    return calculateDayDifference(a.start_date, b.start_date)
  })

  return sortedPriceList[0].price_kg
}
